import React from "react";
import { StoryElement } from "@quintype/components";
import classNames from 'classnames';

class SummaryElement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSummary: true,
      summaryHeight: null
    }
    this.toggleSummary = this.toggleSummary.bind(this);
  }
  toggleSummary() {
    this.setState(function(prevState) {
      return {showSummary: !prevState.showSummary};
    })
  }
  componentDidMount() {
    const height = this.summaryContent.clientHeight;
    this.setState({ summaryHeight: height + 'px' });
  }
  render() {
    let summaryStyle = {
      height: this.state.summaryHeight
    };
    return <div className="story-element-text-summary__wrapper">
      <header>
        Summary
        <div onClick={this.toggleSummary} className={classNames("summary-element__icon-wrap", {'is-closed': !this.state.showSummary})}>
          <Caret />
        </div>
      </header>
      <div
        style={summaryStyle}
        className={classNames('story-element-text-summary__content', {'is-closed': !this.state.showSummary})}
        ref={ (summaryContent) => this.summaryContent = summaryContent}>
        <StoryElement {...this.props}></StoryElement>
      </div>
    </div>
  }
}

const Caret = ({width=21, height=11}) => (
  <svg
    className="summary-element__caret-icon" xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 21 11'>
      <path fill='none' stroke='#FCFCFC' strokeLinecap='round' strokeWidth='1.461'
      d='M20 10l-9.656-9L1 10' />
  </svg>)

export { SummaryElement };
